export default "__VITE_ASSET__CWw$Fpud__"